import React, { Component } from 'react';
import NuevaSolicitudDrodpdown from './NuevaSolicitudDropdown';
import { GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';

let TarjetaPara = '';
let _poseeResponsablesSinTarjetas = false;
class NuevaTarjetaForm extends Component {

    constructor(props) {
        super(props);
        this.titular = null;
    }

    changeResponsable(event) {
        if (event.target.value != 0)
            this.props.changeResponsable(parseInt(event.target.value));
        TarjetaPara = $('#selectResponsable option:selected').text();
    }

    selectLimite(event) {
        if (event.target.value != 0)
            this.props.changeLimite(parseInt(event.target.value));
    }

    selectProductoIbs(event) {
        if (event.target.value != 0)
            this.props.changeProductoIbs(parseInt(event.target.value));
    }

    selectDomicilio(event) {
        /*Comento para que se puede deseleccionar un domicilio. Al intentar agregar la tarjeta la validacion será quien impida continuar*/
        //if (event.target.value != -1)
        this.props.changeDomicilio(parseInt(event.target.value));
    }
    ValueCuil(value) {
        if (value.length == 11) {
            value = value.slice(2, -1);
        }
        return value;
    }

    componentDidMount() {
        TarjetaPara = '';
    }
    agregarTarjeta(tarjetasData) {

        window.scrollTo(0, 0);

        let codigo = 0;

        let deliveryData = this.props.data;
        //Se fija que los campos de los combos esten seleccionados...
        if (deliveryData.cuentaSeleccionada !== undefined
            && deliveryData.limitesSeleccionado > 0
            && deliveryData.productoibsSeleccionado > 0
            && deliveryData.domicilioSeleccionado > 0) {

            if (this.props.tarjetasData !== undefined && this.props.tarjetasData.length > 0)
                this.titular = this.props.tarjetasData.filter(t => t.titular_cuenta !== "")[0];

            let NumeroDocumento;
            let nombreResponsable;
            let puedeGuardar = true;
            let vinculo = 'Titular';
            let vinculoCliente = 1;
            if (this.props.data.cuentaSeleccionada.Vinculo == 1 || this.props.data.cuentaSeleccionada.Vinculo == 4 || this.props.data.cuentaSeleccionada.Vinculo == 3) {
                if (deliveryData.responsableSeleccionado > 0) {
                    let resp = this.props.data.responsables.find(x => x.CliVinCod == this.props.data.responsableSeleccionado);
                    if (resp !== undefined){
                        nombreResponsable = resp.Cliente;
                        NumeroDocumento = resp.NroDoc;
                        vinculoCliente = resp.CliVinCod;
                        if (this.ValueCuil(this.titular.NumeroDocumento) !== resp.NroDoc)
                            vinculo='Adicional'
                    } else {
                        nombreResponsable = "";
                    }               
                } else {
                    if (this.props.data.responsables !== undefined && _poseeResponsablesSinTarjetas) {
                        puedeGuardar = false;
                        this.props.showError(true);
                    }
                    else {
                        nombreResponsable = this.props.data.responsables.find( x => x.NroDoc == this.props.data.cuentaSeleccionada.NumeroDocumentoCtaRelac).Cliente//this.props.data.cuentaSeleccionada.NombreCuenta;
                        NumeroDocumento = this.props.data.cuentaSeleccionada.NumeroDocumentoCtaRelac;
                    }
                }
            } else {
                nombreResponsable = this.props.data.cuentaSeleccionada.NombreCuenta;
            }

            if (puedeGuardar) {

                /*Se busca la descripcion del tipo tarjeta*/
                const tipoTarjeta = deliveryData.productosIbs.find((prod) => prod.Id == deliveryData.productoibsSeleccionado);

                let cantidadTarjetas2 = 0;
                if (this.props.data.cuentaSeleccionada !== undefined) {
                    for (var i = 0; i < tarjetasData.length; i++) {
                        if (tarjetasData[i].NumeroCuenta.toString() == this.props.data.cuentaSeleccionada.CodigoCuenta)
                            cantidadTarjetas2++;
                    }
                }
              
                const tarjeta = {
                    key: this.props.data.cuentaSeleccionada.CodigoCuenta + "-" + Date.now(),
                    titular: false,
                    Nombre: nombreResponsable,
                    DescripcionTarjeta: ' ',
                    Numero: '------------------',
                    Vinculo: vinculo,
                    SucursalId: ' ',
                    LimiteDescripcion: this.props.plasticos.limites.find(x => x.CodigoLimite == this.props.data.limitesSeleccionado).LimiteDescripcion,
                    Activo: 2,
                    domicilioResponsable: this.props.plasticos.domicilios.find(x => x.LOCALIDAD == this.props.data.domicilioSeleccionado),
                    NumeroCuenta: this.props.data.cuentaSeleccionada.CodigoCuenta,
                    DescripcionProducto: tipoTarjeta.Descripcion,
                    LimiteId: this.props.data.limitesSeleccionado,
                    ProductoId: deliveryData.productoibsSeleccionado,
                    NumeroDocumento: NumeroDocumento,
                    VinculoCliente: vinculoCliente
                };

                this.props.addTarjeta(tarjeta);
            }
        } else {
            this.props.showError(true);
        }
    }

    render() {
        //Adapta los datos al combo generico de NuevaSolicitud...


        let tarjetas = this.props.tarjetasData
        let responsableResult = undefined;
        if (this.props.data.responsables !== undefined) {

            for (var i = 0; i < this.props.data.responsables.length; i++) {
                if (this.props.data.responsables.PoseeTarjetas)
                    _poseeResponsablesSinTarjetas = true;
            };

            responsableResult = this.props.data.responsables.map((responsable) => {
                if (!responsable.PoseeTarjetas) {
                    return (
                        <GenericOption key={responsable.CliVinCod} id={responsable.CliVinCod} description={responsable.Cliente} />
                    )
                }

            });           
        }

        let limitesResult;
        if (this.props.plasticos.limites !== undefined) {
            limitesResult = this.props.plasticos.limites.map((limite) => {
                return (
                    <GenericOption key={limite.CodigoLimite} id={limite.CodigoLimite} description={limite.Sintetico === undefined ? limite.LimiteDescripcion : limite.Sintetico + " - " + limite.LimiteDescripcion} />
                )
            })
        }

        let productosIbsResult;
        if (this.props.data.productosIbs !== undefined) {
            productosIbsResult = this.props.data.productosIbs.map((producto) => {
                return (
                    <GenericOption key={producto.Id} id={producto.Id} description={producto.Descripcion} />
                )
            })
        }

        let domiciliosResult;
        if (this.props.plasticos.domicilios !== undefined) {
            domiciliosResult = this.props.plasticos.domicilios.map((domicilio) => {
                if (domicilio.LOCALIDAD != -1) {
                    return (
                        <GenericOption key={domicilio.LOCALIDAD} id={domicilio.LOCALIDAD}
                            description={domicilio.CALLE + " " + domicilio.NUMERO_CALLE + ", " + domicilio.DESC_PROVINCIA + ", " + domicilio.CODIGO_POSTAL + " (" + domicilio.DESC_TIPO_DOMIC + ")"} />
                    )
                } else {
                    return (
                        <GenericOption key={domicilio.LOCALIDAD} id={domicilio.LOCALIDAD}
                            description={"Seleccione..."} />
                    )
                }
            })
        }

        if (this.props.tarjetasData !== undefined) {

            const { tarjetasData } = this.props;
            let tarjetasTitular = this.titular;
            let nombreCuenta = ( this.props.data.cuentaSeleccionada !== undefined && this.props.data.responsables !== undefined ) ? this.props.data.responsables.find( x => x.NroDoc == this.props.data.cuentaSeleccionada.NumeroDocumentoCtaRelac && x.CliVinCod == 1 ).Cliente : "";

            let titularSelect = this.props.cuentaPoseePlasticos ?
                <GenericSelect
                    id="selectResponsable"
                    className="form-control default-select"
                    options={responsableResult}
                    value={this.props.data.responsableSeleccionado}
                    onChange={(e) => this.changeResponsable(e)}
                /> : <div><label>{nombreCuenta}</label></div>;

            let cantidadTarjetas = 0;
            if (this.props.data.cuentaSeleccionada !== undefined) {
                for (var i = 0; i < tarjetasData.length; i++) {
                    if (tarjetasData[i].NumeroCuenta.toString() == this.props.data.cuentaSeleccionada.CodigoCuenta)
                        cantidadTarjetas++;
                }
            }

            let tipoConsulta = "";
            if (this.props.plasticos.cuentasDelivery && this.props.data.functions !== undefined) {
                if (this.props.data.functions.Socioversuc !== undefined || this.props.data.functions.Socioverbanco) {

                    if (this.props.data.functions.Socioverbanco) {
                        tipoConsulta = "BANCO";
                    } else if (this.props.data.functions.Socioversuc) {
                        tipoConsulta = "SUCURSAL";
                    }
                }
            }

            return (
                <div id="divNuevaTarjetaForm" className="nuevasolicitud-form-alta">
              
                    {TarjetaPara != '' ? <div className="NuevaTarjetaFormTitle"> <h3 className="quitar-margen">Nueva tarjeta para: </h3> <h3 className="color-header-numero-cuenta quitar-margen"> <strong>{TarjetaPara}</strong></h3></div> : ''}                

                    <div className="NuevaTarjetaFormDropdown">
                        <label className="label-secondary"><strong>Responsable de la tarjeta</strong></label>                        
                        {titularSelect}
                    </div>

                    <div className="NuevaTarjetaFormTipo">
                        <label className="label-secondary"><strong>Tipo de tarjeta</strong></label>
                        <br />
                        <GenericSelect
                            id="selectProductoibs"
                            className="form-control default-select"
                            options={productosIbsResult}
                            value={this.props.data.productoibsSeleccionado}
                            onChange={(e) => this.selectProductoIbs(e)}
                        />
                    </div>

                    <div className="NuevaTarjetaFormTipo">
                        <label className="label-secondary"><strong>Domicilio</strong></label>
                        <GenericSelect
                            id="selectDomicilioNuevaSolicitud"
                            className="form-control default-select"
                            options={domiciliosResult}
                            value={this.props.data.domicilioSeleccionado}
                            onChange={(e) => this.selectDomicilio(e)}
                        />
                    </div>

                    <div className="NuevaTarjetaFormTipo">
                        <label className="label-secondary"><strong>Límite de débito</strong></label>
                        <br />
                        {tipoConsulta === "BANCO" ? <GenericSelect
                            id="selectLimite"
                            className="form-control default-select"
                            options={limitesResult}
                            value={this.props.data.limitesSeleccionado}
                            onChange={(e) => this.selectLimite(e)}
                        /> :
                            <label>{this.props.data.limites !== undefined && this.props.data.limites.find(x => x.Id == this.props.data.limitesSeleccionado) !== undefined ? this.props.data.limites.find(x => x.Id == this.props.data.limitesSeleccionado).LimiteDescripcion
                                : "Selecciones un tipo de tarjeta"}</label>}
                        <br />
                        <label className="label-secondary">El límite podrá ser modificado una vez que la tarjeta esté habilitada.</label>
                    </div>

                    <div className="nuevasolicitud-boton-agregar-tarjeta">
                        <button id="btnAgregarTarjeta" type="button" className="btn btn-secondary" onClick={() => this.agregarTarjeta(tarjetasData)}>
                            Agregar esta tarjeta
                        </button>
                    </div>

                </div>
            );
        } else {
            return null;
        }
    }

}

export default NuevaTarjetaForm;
